export default ({
  isServer,
  isBoxenUser,
  internalServerUrl,
  baseUrl
}) => {
  let apiUrlPrefix = ''
  // on client side there's no need for prefix, browser will append it for us
  if (isServer) {
    if (isBoxenUser) {
      apiUrlPrefix = baseUrl
    } else {
      apiUrlPrefix = internalServerUrl
    }
  }
  return apiUrlPrefix
}



// WEBPACK FOOTER //
// ./common/utils/getProxyApiUrl.js